import config from "./config";
import { simBackend } from "./sim-backend";


// send request to simBackend directly (without adapter)
export const sendReqToSimBackendDirect = async (simEndpoint, simMethod, simHeaders = {}, simBody = {}, simQueryParams = {}, simRouteParams = {}) => {
  // ignore the config and always use simBackend directly
  // fromCoordRoleserverToSimBackend
  /*
  const {
    simEndpoint,
    simMethod,
    simHeaders,
    simBody,
    simQueryParams,
    simRouteParams
  } = sim_req;
  */
  if (typeof simBackend[simEndpoint] === 'function') {
    // console.log('sendReqToSimBackendDirect', Date.now());
    const res = await simBackend[simEndpoint](simMethod, simHeaders, simBody, simQueryParams, simRouteParams);
    // console.log('sendReqToSimBackendDirect', Date.now());
    return res;
  }
  return false;
};


// send request to simBackens with adapter
export const simBackendAdapter = async (simEndpoint, simMethod, simHeaders = {}, simBody = {}, simQueryParams = {}, simRouteParams = {}) => {
  /*
  const {
    simEndpoint,
    simMethod,
    simHeaders,
    simBody,
    simQueryParams,
    simRouteParams
  } = sim_req;
  */
  if (config.via_c2c_exchange_server === true) {
    /*
    const res = send_req_via_c2c_exchange_server(simEndpoint, simHeaders, simBody, simQueryParams, simRouteParams)
    return res;
    */
  } else {
    if (typeof simBackend[simEndpoint] === 'function') {
      const res = await simBackend[simEndpoint](simMethod, simHeaders, simBody, simQueryParams, simRouteParams);
      return res;
    }
  }
  return false;
};

